import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BandeauComponent } from './bandeau/bandeau.component';
import { PiedComponent } from './pied/pied.component';
import { PrincipalComponent } from './principal/principal.component';
import { RappelsComponent } from './principal/rappels/rappels.component';
import { TracarticlesComponent } from './principal/tracarticles/tracarticles.component';
import { GestionclientsComponent } from './principal/gestionclients/gestionclients.component';
import { DeposerarticlesmodalComponent } from './principal/gestionclients/deposerarticlesmodal/deposerarticlesmodal.component';
import { AjoutpersonneModalComponent } from './principal/gestionclients/ajoutpersonnemodal/ajoutpersonnemodal.component';
import { AchatarticlesModalComponent } from './principal/gestionclients/achatarticlesmodal/achatarticlesmodal.component';
import { SolderdepotmodalComponent } from './principal/gestionclients/solderdepotmodal/solderdepotmodal.component';

@NgModule({
  declarations: [
    AppComponent,
    BandeauComponent,
    PiedComponent,
    PrincipalComponent,
    RappelsComponent,
    TracarticlesComponent,
    GestionclientsComponent,
    DeposerarticlesmodalComponent,
    AjoutpersonneModalComponent,
    AchatarticlesModalComponent,
    SolderdepotmodalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
